// Import All Resources
import Vue from 'vue'
import App from './App.vue'
import Vuex from 'vuex'
import { store } from './store'
import router from './router'
import {CallApi, fileToB64} from './Utilities'

Vue.config.productionTip = false
Vue.use(Vuex)

// Bootstrap App
function Bootstrap() {
	// Our Vue Start Function
	const startFunction = function () {
		// Load any User Info from Session Store
		const localUser = localStorage.getItem("user");
		if (localUser !== null && localUser != {}) {
			store.User = JSON.parse(localUser)
			try {
				store.organization_types = JSON.parse(localStorage.getItem("organization_types"))
				store.interaction_types = JSON.parse(localStorage.getItem("interaction_types"))
				store.salesstages = JSON.parse(localStorage.getItem("salesstages"))
			} catch (err) {
				store.organization_types = null
				store.interaction_types = null
				store.salesstages = null
			}
		}

		// Define Vue Filters
		Vue.filter('date', (date) => (new Date(date)).toLocaleDateString('en-Au'))
		Vue.filter('truncate', function (text, n) {
			try {
				return text.substr(0,n) + ((text.length > n) ? '…':'')
			} catch (e) {
				return ""
			}
		})
		Vue.filter('capitalize', function (text) {
			try {
				const a = text.slice(0,1); return a.toUpperCase() + text.slice(1)
			} catch (err) {
				return ""
			}
		})
		
		// Launch Vue
		new Vue({
			router,
			render: h => h(App),
			store,
		}).$mount('#app')

		// Register our Call Api Function
		window.CallApi = CallApi
		window.fileToB64 = fileToB64
	}

	// Run startFunction as soon as DOM is Loaded
	if (document.readyState === "complete" || document.readyState === "interactive") {
		setTimeout(startFunction, 1);
	} else {
		document.addEventListener("DOMContentLoaded", startFunction);
	}
}
Bootstrap()